import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "src/environments/environment";
import { clearAuthStorage, readStoredValue } from "../auth/auth-storage";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly apiHost = this.extractApiHostname(environment.apiHost);

  constructor(private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const tenantRequest = this.isTenantApiRequest(req.url);
    const token = readStoredValue("token");

    const request = tenantRequest && token && !req.headers.has("Authorization")
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      : req;

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && tenantRequest) {
          const isSubscriptionEndpoint = req.url.includes('/subscribe') || req.url.includes('/stripe/subscribe');
          if (!isSubscriptionEndpoint) {
            clearAuthStorage();
            this.router.navigate(["/auth/signin"]);
          }
        }

        return throwError(error);
      })
    );
  }

  private isTenantApiRequest(url: string): boolean {
    try {
      const parsed = new URL(url);
      return parsed.hostname.endsWith(`.${this.apiHost}`);
    } catch {
      return false;
    }
  }

  private extractApiHostname(apiHost: string): string {
    return apiHost.replace(/^https?:\/\//, "").replace(/\/.*$/, "").replace(/\/$/, "");
  }
}
